import React, { useState } from 'react';
import AuroraBackground from '../components/AuroraBackground';

const Sup = ({ children }) => <sup className="ml-0.5 align-super text-[0.7em]">{children}</sup>;

const servicePlans = [
  { name: 'Essential' },
  { name: 'Advanced' },
  { name: 'Premium' },
];

const features = [
  {
    label: (
      <span>
        Extended Warranty<Sup>1</Sup>
      </span>
    ),
    values: [
      { type: 'text', content: '1 Year' },
      { type: 'text', content: '2 Years' },
      { type: 'text', content: 'Lifetime' },
    ],
  },
  {
    label: 'Manufactured in Australia',
    values: [{ type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: '100% Australian-based Server Hosting',
    values: [{ type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Standard Repair Service Within 10 Business Days',
    values: [{ type: 'icon', content: 'close' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: (
      <span>
        Temporary Unit Replacement provided if repair exceeds 10 business days<Sup>2</Sup>
      </span>
    ),
    values: [{ type: 'icon', content: 'close' }, { type: 'icon', content: 'close' }, { type: 'icon', content: 'check' }],
  },
  {
    label: '4G Data Package Included',
    values: [{ type: 'icon', content: 'close' }, { type: 'icon', content: 'close' }, { type: 'icon', content: 'check' }],
  },
  {
    label: '4G Connectivity for Remote Communication',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Automatic Power-Saving Mode When Battery Level Critical',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Remote Access Control via Web Platform',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: (
      <span>
        Real-time GPS Tracking Capability<Sup>3</Sup>
      </span>
    ),
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Device Tilt Detection',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Door Open Detection',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Cabinet and Battery Temerature Monitoring',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Automatic Time Synchronization',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Adjustable Speed Limit Functionality',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Image Content Upload Capability',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Hourly Automated Screen Brightness Adjustment',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Pre-Configured Display Mode Presets',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Remotely Update Content To Device',
    values: [{ type: 'icon', content: 'partial' }, { type: 'text', content: 'Up to 100 Images' }, { type: 'text', content: 'Up to 1,000 Images' }],
  },
  {
    label: 'Access to Traffic Activity Logs',
    values: [{ type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Traffic Data Log Download',
    values: [{ type: 'icon', content: 'close' }, { type: 'icon', content: 'close' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Group Device Control - Apply Changes to Multiple Device At Once',
    values: [{ type: 'icon', content: 'close' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Schedule Content Display Management',
    values: [{ type: 'icon', content: 'close' }, { type: 'icon', content: 'check' }, { type: 'icon', content: 'check' }],
  },
  {
    label: 'Calendar-Based Scheduling (Ideal for School Zones and Public Holidays)',
    values: [{ type: 'icon', content: 'close' }, { type: 'icon', content: 'close' }, { type: 'icon', content: 'check' }],
  },
  {
    label: (
      <span>
        Video Playing Support (Upcoming<Sup>4</Sup>)
      </span>
    ),
    values: [{ type: 'icon', content: 'close' }, { type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }],
  },
  {
    label: (
      <span>
        Instant Emegency Response Messaging (Upcoming<Sup>4</Sup>)
      </span>
    ),
    values: [{ type: 'icon', content: 'close' }, { type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }],
  },
  {
    label: (
      <span>
        SMS/Email Alerts for Low Battery, GPS movement, High/Low Temperature, Door Status, and More
        (Upcoming<Sup>4</Sup>)
      </span>
    ),
    values: [{ type: 'icon', content: 'close' }, { type: 'icon', content: 'partial' }, { type: 'icon', content: 'check' }],
  },
];

// Pull plain text out of a label (which may be a JSX <span> with a superscript) so
// rows can be sorted alphabetically.
const labelText = (label) => {
  if (label == null) return '';
  if (typeof label === 'string' || typeof label === 'number') return String(label);
  if (Array.isArray(label)) return label.map(labelText).join('');
  if (label.props && label.props.children) return labelText(label.props.children);
  return '';
};

const checkCount = (f) => f.values.filter((v) => v.type === 'icon' && v.content === 'check').length;
const hasText = (f) => f.values.some((v) => v.type === 'text');

// Row order: text rows first, then 1 tick → 2 ticks → 3 ticks (all identical),
// alphabetical within each group.
const groupRank = (f) => (hasText(f) ? -1 : checkCount(f));
const orderedFeatures = [...features].sort((a, b) => {
  const diff = groupRank(a) - groupRank(b);
  return diff !== 0 ? diff : labelText(a.label).localeCompare(labelText(b.label));
});

const footnotes = [
  '1  Warranty does not cover damage caused by external sources.',
  '2  Subject to availability and applicable terms of service.',
  '3  GPS accuracy may vary based on environmental conditions.',
  '4  Features currently under development and subject to changes.'
];

const CheckIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" className="h-5 w-5 text-emerald-500" aria-label="Included">
    <circle cx="10" cy="10" r="9" className="fill-emerald-500/10" />
    <path d="M6 10.5l2.5 2.5L14 7.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const CloseIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" className="h-5 w-5 text-slate-300" aria-label="Not included">
    <path d="M6.5 6.5l7 7M13.5 6.5l-7 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);
const PartialIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" className="h-5 w-5 text-amber-500" aria-label="Optional">
    <circle cx="10" cy="10" r="6.5" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const renderIcon = (content) =>
  content === 'check' ? <CheckIcon /> : content === 'close' ? <CloseIcon /> : <PartialIcon />;

// 4-column grid: feature label + 3 plan columns.
const ROW = 'grid grid-cols-[1.6fr_1fr_1fr_1fr]';

const ServicePlans = () => {
  const [hovered, setHovered] = useState(null);
  const colTint = (i) => (hovered === i ? 'bg-slate-50' : '');

  return (
    <div className="relative min-h-screen overflow-hidden bg-white">
      <AuroraBackground />

      <div className="relative z-10 mx-auto max-w-[1100px] px-6 py-24 md:py-28">
        {/* Header */}
        <header className="mb-14 max-w-[780px]">
          
          <h1 className="text-[2.5rem] font-extrabold leading-[1.05] tracking-[-1.5px] text-[#0f172a] md:text-[3.25rem]">
            Service Plans
          </h1>
        </header>

        {/* Comparison table */}
        <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white/80 shadow-[0_8px_30px_rgba(15,23,42,0.05)] backdrop-blur-sm">
          <div className="min-w-[760px]">
            {/* Header row */}
            <div className={`${ROW} sticky top-0 z-10 border-b border-slate-200 bg-slate-50/90 backdrop-blur-sm`}>
              <div className="p-4 text-sm font-bold text-[#0f172a]">Feature</div>
              {servicePlans.map((plan, i) => (
                <div
                  key={i}
                  onMouseEnter={() => setHovered(i)}
                  onMouseLeave={() => setHovered(null)}
                  className={`border-l border-slate-200 p-4 text-sm font-bold bg-[linear-gradient(135deg,#ff3b30,#30d158,#0a84ff)] bg-clip-text text-transparent transition-colors ${colTint(i)}`}
                >
                  {plan.name}
                </div>
              ))}
            </div>

            {/* Feature rows */}
            {orderedFeatures.map((feature, index) => {
              // If every plan shares the same value, merge into one cell spanning
              // all plan columns instead of repeating the same icon/text.
              const first = feature.values[0];
              const allSame = feature.values.every(
                (v) => v.type === first.type && v.content === first.content
              );
              return (
                <div
                  key={index}
                  className={`${ROW} border-b border-slate-100 transition-colors last:border-b-0 hover:bg-slate-50/80`}
                >
                  <div className="flex items-center p-4 text-sm font-medium text-[#0f172a]">{feature.label}</div>
                  {allSame ? (
                    <div className="col-span-3 flex items-center justify-center gap-1 border-l border-slate-100 p-4 text-center text-sm text-slate-600">
                      {first.type === 'icon' ? renderIcon(first.content) : first.content}
                    </div>
                  ) : (
                    feature.values.map((value, i) => (
                      <div
                        key={i}
                        onMouseEnter={() => setHovered(i)}
                        onMouseLeave={() => setHovered(null)}
                        className={`flex items-center gap-1 border-l border-slate-100 p-4 text-sm text-slate-600 transition-colors ${colTint(i)}`}
                      >
                        {value.type === 'icon' ? renderIcon(value.content) : value.content}
                      </div>
                    ))
                  )}
                </div>
              );
            })}

            {/* Footnotes */}
            <div className="space-y-1 border-t border-slate-200 bg-slate-50/70 p-4">
              {footnotes.map((note, i) => (
                <p key={i} className="text-xs italic leading-relaxed text-slate-400">
                  {note}
                </p>
              ))}
              {/* Icon legend with your actual table icons */}
              <p className="text-xs italic leading-relaxed text-slate-400 flex items-center gap-2 flex-wrap mt-2">
                Icon legend:
                <span className="flex items-center gap-1"><CheckIcon /> Included,</span>
                <span className="flex items-center gap-1"><PartialIcon /> Optional add-on,</span>
                <span className="flex items-center gap-1"><CloseIcon /> Not included</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicePlans;
